import { render } from "./ShowCarDetails.vue?vue&type=template&id=1cbe425e&scoped=true"
import script from "./ShowCarDetails.vue?vue&type=script&lang=js"
export * from "./ShowCarDetails.vue?vue&type=script&lang=js"

import "./ShowCarDetails.vue?vue&type=style&index=0&id=1cbe425e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\vue_php_crud\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbe425e"]])

export default __exports__